import { useFormContext } from 'react-hook-form'

import { Trades } from '@fortem-monorepo/web-sdk'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { ClientIdFormField } from '@/pages/trading/new-trade/fields/ClientIdFormField'
import { CommentFormField } from '@/pages/trading/new-trade/fields/CommentFormField'
import { TradeTypeFormField } from '@/pages/trading/new-trade/fields/TradeTypeFormField'
import { TraderIdFormField } from '@/pages/trading/new-trade/fields/TraderIdFormField'
import {
  useTradeClientsQuery,
  useTradeTypesQuery,
  useTradersQuery,
} from '@/react-query/queries/static'

export interface BespokeStrategyFormFieldsProps {}

export const BespokeStrategyFormFields: React.FC<BespokeStrategyFormFieldsProps> = ({}) => {
  const { watch } = useFormContext<Trades.BookTradeBody>()

  const tradeTypesQuery = useTradeTypesQuery()
  const tradeClientsQuery = useTradeClientsQuery()

  const org_id = watch('client_id')

  const tradersQuery = useTradersQuery({ org_id, is_internal: false })

  return (
    <div className="flex flex-col gap-4">
      <FormFieldRow>
        <ClientIdFormField
          clients={tradeClientsQuery.data}
          loading={tradeClientsQuery.isFetching}
        />
        <TraderIdFormField
          traders={tradersQuery.data}
          loading={tradersQuery.isFetching}
          disabled={!org_id}
        />
        <TradeTypeFormField
          tradeTypes={tradeTypesQuery.data}
          loading={tradeTypesQuery.isFetching}
        />
      </FormFieldRow>
      <CommentFormField />
    </div>
  )
}
